import { Component, QueryList, ViewChildren } from '@angular/core';
import { take, tap } from 'rxjs/operators';

import { ValComponentBaseComponent } from '../common/modules/val-component-base/val-component-base.component';
import { ValService } from '../services/val.service';

@Component({
  selector: 'val-forgot-password',
  templateUrl: './val-forgot-password.component.html',
  styleUrls: ['./val-forgot-password.component.scss']
})
export class ValForgotPasswordComponent {
  @ViewChildren('v') private _validationFields: QueryList<ValComponentBaseComponent>;
  public userName = '';
  public email = '';
  public success = false;

  constructor(
    private _srvc: ValService
  ) { }

  public send = () => {
    this.success = false;
    let valid = true;
    if (this._validationFields) {
      this._validationFields.forEach(x => {
        x.apply();
        const v = x.validate();
        if (!v) {
          valid = false;
        }
      });
    }
    if (!valid) { return; }
    this._srvc.forgotPassword(this.userName, this.email).pipe(
      take(1),
      tap(() => {
        this.success = true;
      })).subscribe();
  }
}


